/// Cart ///
document.addEventListener('DOMContentLoaded', function () {
  const cartDrawer = document.getElementById('CartDrawer');
  const cartDrawerOverlay = document.getElementById('CartDrawerOverlay');
  const cartDrawerContent = document.getElementById('CartDrawerContent');
  const closeCartDrawerButton = document.getElementById('CloseCartDrawer');
  const cartCountElement = document.getElementById('CartCount');
  const cartType = (window.cartType || (document.getElementById('CartDrawer') ? 'drawer' : 'page'));

  function openCartDrawer() {
    if (cartType !== 'drawer' || !cartDrawer || !cartDrawerOverlay) return;

    cartDrawer.classList.add('open');
    cartDrawer.style.right = '0';
    cartDrawer.style.opacity = '1';
    cartDrawer.style.visibility = 'visible';
    cartDrawer.style.display = 'flex';

    // Always on top
    cartDrawer.style.zIndex = '999999';
    cartDrawerOverlay.style.zIndex = '999998';

    cartDrawerOverlay.classList.add('active');

    // Lock page scrolling
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    updateCartDrawer();
  }

  function closeCartDrawer() {
    if (!cartDrawer || !cartDrawerOverlay) return;

    cartDrawer.classList.remove('open');
    cartDrawer.style.right = '-100%';
    cartDrawer.style.opacity = '';
    cartDrawer.style.visibility = '';
    cartDrawer.style.display = '';

    cartDrawerOverlay.classList.remove('active');

    // Re-enable page scrolling
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }

  if (cartDrawerOverlay) {
    cartDrawerOverlay.addEventListener('click', function () {
      closeCartDrawer();
    });
  }

  if (closeCartDrawerButton) {
    closeCartDrawerButton.addEventListener('click', function () {
      closeCartDrawer();
    });
  }

  document.addEventListener('click', function (event) {
    if (
      cartDrawer &&
      cartDrawer.classList.contains('open') &&
      !cartDrawer.contains(event.target) &&
      !event.target.closest('a[href*="/cart"]')
    ) {
      closeCartDrawer();
    }
  });

  function updateCartCount(cartItemCount) {
    if (cartCountElement) {
      cartCountElement.textContent = cartItemCount;
    }
  }

  function updateCartDrawerTotal() {
    const totalElement = document.querySelector('#CartDrawerTotal');
    if (!totalElement) return;

    fetch('/cart?view=cart-drawer')
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Failed to fetch cart drawer content');
        }
        return response.text();
      })
      .then(function (html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const updatedTotal = doc.querySelector('#CartDrawerTotal');
        if (updatedTotal) {
          totalElement.innerHTML = updatedTotal.innerHTML;
        }
      })
      .catch(function (error) {
        console.error('Error updating cart total:', error);
      });
  }

  function removeCartItem(key, removeButton) {
    const cartItem = removeButton.closest('.cart-drawer-item');
    if (cartItem) {
      cartItem.classList.add('fade-out-bck');
    }

    setTimeout(function () {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Failed to remove item from cart');
          }
          return response.json();
        })
        .then(function (cart) {
          updateCartDrawer();
          updateCartDrawerTotal();
          updateCartCount(cart.item_count);
        })
        .catch(function (error) {
          console.error('Error removing cart item:', error);
        });
    }, 200);
  }

  function attachRemoveHandlers() {
    document.querySelectorAll('.cart-drawer-item__remove-link').forEach(function (removeButton) {
      if (removeButton.dataset.cartRemoveBound === 'true') return;
      removeButton.dataset.cartRemoveBound = 'true';

      removeButton.addEventListener('click', function (event) {
        event.preventDefault();
        const key = this.dataset.key;
        if (!key) return;
        removeCartItem(key, this);
      });
    });
  }

  function attachQuantityHandlers() {
    document.querySelectorAll('.quantity-wrapper-drawer').forEach(function (wrapper) {
      if (wrapper.dataset.cartQtyBound === 'true') return;
      wrapper.dataset.cartQtyBound = 'true';

      const key = wrapper.dataset.key;
      const inventoryQuantity = parseInt(wrapper.dataset.inventory, 10);
      const trackQuantity = wrapper.dataset.trackQuantity === 'true';
      const allowOversell = wrapper.dataset.allowOversell === 'true';

      const minusButton = wrapper.querySelector('.cart-drawer__quantity-btn-minus');
      const plusButton = wrapper.querySelector('.cart-drawer__quantity-btn-plus');
      const quantityValue = wrapper.querySelector('.cart-drawer__quantity-value');

      if (!key || !quantityValue) return;

      function updateButtonStates() {
        const currentQuantity = parseInt(quantityValue.textContent, 10) || 1;

        if (minusButton) {
          const disableMinus = currentQuantity <= 1;
          minusButton.classList.toggle('disabled', disableMinus);
          minusButton.disabled = disableMinus;
        }

        if (plusButton) {
          if (trackQuantity && !allowOversell) {
            const isMaxQuantity = currentQuantity >= inventoryQuantity;
            plusButton.classList.toggle('disabled', isMaxQuantity);
            plusButton.disabled = isMaxQuantity;
          } else {
            plusButton.classList.remove('disabled');
            plusButton.disabled = false;
          }
        }
      }

      function updateCartQuantity(quantity) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: key,
            quantity: quantity
          })
        })
          .then(function (response) {
            if (!response.ok) {
              throw new Error('Error updating cart');
            }
            return response.json();
          })
          .then(function (cart) {
            quantityValue.textContent = quantity;
            wrapper.dataset.quantity = quantity;
            updateButtonStates();
            updateCartDrawerTotal();
            updateCartCount(cart.item_count);
          })
          .catch(function (error) {
            console.error('Error updating cart quantity:', error);
          });
      }

      if (minusButton) {
        minusButton.addEventListener('click', function () {
          const currentQuantity = parseInt(quantityValue.textContent, 10) || 1;
          if (currentQuantity > 1) {
            updateCartQuantity(currentQuantity - 1);
          }
        });
      }

      if (plusButton) {
        plusButton.addEventListener('click', function () {
          const currentQuantity = parseInt(quantityValue.textContent, 10) || 1;
          if (trackQuantity && !allowOversell && currentQuantity >= inventoryQuantity) {
            alert('Maximum quantity for this product is ' + inventoryQuantity + '.');
          } else {
            updateCartQuantity(currentQuantity + 1);
          }
        });
      }

      updateButtonStates();
    });
  }

  function updateCartDrawer() {
    if (!cartDrawerContent) return;

    fetch('/cart?view=cart-drawer')
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newContent = doc.getElementById('CartDrawerContent');
        if (newContent) {
          cartDrawerContent.innerHTML = newContent.innerHTML;
          attachRemoveHandlers();
          attachQuantityHandlers();
        }
      })
      .catch(function (error) {
        console.error('Error updating cart drawer:', error);
      });
  }

  function bindCartTriggers(root) {
    if (!root) return;

    root.querySelectorAll('a[href*="/cart"], button[data-cart-drawer-toggle], .js-cart-toggle').forEach(function (cartTrigger) {
      if (cartTrigger.dataset.cartLinkBound === 'true') return;
      cartTrigger.dataset.cartLinkBound = 'true';

      cartTrigger.addEventListener('click', function (event) {
        if (cartType === 'drawer') {
          event.preventDefault();
          openCartDrawer();
        }
      });
    });
  }

  const addToCartForm = document.getElementById('AddToCartForm');
  if (addToCartForm && !addToCartForm.dataset.cartFormBound) {
    addToCartForm.dataset.cartFormBound = 'true';

    let isSubmitting = false;

    addToCartForm.addEventListener('submit', async function (event) {
      event.preventDefault();

      if (isSubmitting) return;
      isSubmitting = true;

      const submitBtn = addToCartForm.querySelector('.product-info__cart-btn');
      const originalText = submitBtn ? submitBtn.innerHTML : '';

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerHTML = 'Adding...';
      }

      try {
        const idInput = addToCartForm.querySelector('input[name="id"]');

        if (!idInput || !idInput.value) {
          throw new Error('Missing variant ID');
        }

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: idInput.value,
            quantity: 1
          })
        });

        if (!response.ok) {
          const errorText = await response.text();
          console.error(errorText);
          throw new Error('Add to cart failed');
        }

        const cart = await fetch('/cart.js').then(r => r.json());

        updateCartCount(cart.item_count);

        if (cartType === 'drawer') {
          openCartDrawer();
        } else {
          window.location.href = '/cart';
        }

      } catch (error) {
        console.error('Add to cart error:', error);

        // FALLBACK
        addToCartForm.submit();
        return;

      } finally {
        isSubmitting = false;

        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.innerHTML = originalText;
        }
      }
    });
  }

  bindCartTriggers(document);
  attachRemoveHandlers();
  attachQuantityHandlers();

  document.addEventListener('shopify:section:load', function (event) {
    bindCartTriggers(event.target);
    attachRemoveHandlers();
    attachQuantityHandlers();
  });
});


/// Product cards ///
(function () {
  function setActiveImage(images, index) {
    if (!images || !images.length) return 0;
    var safeIndex = ((index % images.length) + images.length) % images.length;
    for (var i = 0; i < images.length; i++) {
      images[i].classList.toggle('is-active', i === safeIndex);
    }
    return safeIndex;
  }

  function initOneCard(card) {
    if (!card || card.dataset.productCardBound === 'true') return;
    card.dataset.productCardBound = 'true';

    var container = card.querySelector('.product-image-container');
    if (!container) return;

    var link = container.querySelector('a.product-list__img-link');
    if (!link) return;

    var images = Array.from(link.querySelectorAll('img.product-card__image'));
    if (!images.length) return;

    var hasMultiple = images.length > 1;
    var index = 0;

    var prevBtn = container.querySelector('.product-card-arrow--prev');
    var nextBtn = container.querySelector('.product-card-arrow--next');

    function isMobile() {
      return window.matchMedia('(max-width: 748px)').matches;
    }

    function clampIndex(i) {
      if (!images.length) return 0;
      return ((i % images.length) + images.length) % images.length;
    }

    function setActiveDesktop(i) {
      index = clampIndex(i);
      images.forEach(function (img, idx) {
        img.classList.toggle('is-active', idx === index);
      });
    }

    function bindDesktop() {
      setActiveDesktop(0);

      if (!container.dataset.hoverBound) {
        container.dataset.hoverBound = 'true';

        container.addEventListener('mouseenter', function () {
          if (isMobile() || !hasMultiple) return;
          setActiveDesktop(1);
        });

        container.addEventListener('mouseleave', function () {
          if (isMobile() || !hasMultiple) return;
          setActiveDesktop(0);
        });
      }

      if (prevBtn && !prevBtn.dataset.bound) {
        prevBtn.dataset.bound = 'true';
        prevBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (!hasMultiple) return;
          setActiveDesktop(index - 1);
        });
      }

      if (nextBtn && !nextBtn.dataset.bound) {
        nextBtn.dataset.bound = 'true';
        nextBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (!hasMultiple) return;
          setActiveDesktop(index + 1);
        });
      }
    }

    var track = null;
    var startX = 0;
    var startY = 0;
    var dx = 0;
    var dragging = false;
    var decided = false;
    var horizontal = false;
    var width = 1;

    function ensureMobileTrack() {
      if (!hasMultiple) {
        setActiveDesktop(0);
        return null;
      }

      track = link.querySelector('.product-card-track');
      if (!track) {
        track = document.createElement('div');
        track.className = 'product-card-track';

        images.forEach(function (img) {
          track.appendChild(img);
        });
        link.appendChild(track);

        images = Array.from(track.querySelectorAll('img.product-card__image'));
      }

      images.forEach(function (img) {
        img.classList.remove('is-active');
        img.style.position = 'relative';
        img.style.inset = '';
        img.style.opacity = '1';
        img.style.visibility = 'visible';
        img.style.pointerEvents = 'auto';
        img.style.flex = '0 0 100%';
        img.style.width = '100%';
        img.style.height = '100%';
        img.style.objectFit = 'contain';
        img.style.transition = 'none';
      });

      track.style.display = 'flex';
      track.style.height = '100%';
      track.style.willChange = 'transform';
      track.style.transition = 'transform 0.25s ease';
      track.style.transform = 'translateX(0px)';

      index = 0;
      width = container.getBoundingClientRect().width || 1;
      track.style.transform = 'translateX(' + (-index * width) + 'px)';

      return track;
    }

    function setTrackTranslate(px, instant) {
      if (!track) return;
      if (instant) track.style.transition = 'none';
      track.style.transform = 'translateX(' + px + 'px)';
    }

    function snapTo(i) {
      if (!track) return;
      index = clampIndex(i);
      dx = 0;
      width = container.getBoundingClientRect().width || 1;
      track.style.transition = 'transform 0.25s ease';
      track.style.transform = 'translateX(' + (-index * width) + 'px)';
    }

    function bindMobileDrag() {
      if (!hasMultiple) return;

      container.addEventListener(
        'touchstart',
        function (e) {
          if (!isMobile()) return;
          if (!track) ensureMobileTrack();
          if (!track) return;
          if (!e.touches || !e.touches[0]) return;

          width = container.getBoundingClientRect().width || 1;
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;

          dx = 0;
          dragging = true;
          decided = false;
          horizontal = false;

          track.style.transition = 'none';
          track.style.transform = 'translateX(' + (-index * width) + 'px)';
        },
        { passive: true }
      );

      container.addEventListener(
        'touchmove',
        function (e) {
          if (!isMobile()) return;
          if (!dragging || !track) return;
          if (!e.touches || !e.touches[0]) return;

          var x = e.touches[0].clientX;
          var y = e.touches[0].clientY;

          var rawDx = x - startX;
          var rawDy = y - startY;

          if (!decided) {
            if (Math.abs(rawDx) > 8 && Math.abs(rawDx) > Math.abs(rawDy)) {
              horizontal = true;
              decided = true;
            } else if (Math.abs(rawDy) > 10) {
              dragging = false;
              decided = true;
              return;
            }
          }

          if (!horizontal) return;

          e.preventDefault();

          dx = rawDx;

          if (index === 0 && dx > 0) dx *= 0.35;
          if (index === images.length - 1 && dx < 0) dx *= 0.35;

          var base = -index * width;
          setTrackTranslate(base + dx, true);
        },
        { passive: false }
      );

      container.addEventListener(
        'touchend',
        function () {
          if (!isMobile()) return;
          if (!track) return;

          if (!dragging) return;
          dragging = false;

          if (!horizontal) {
            snapTo(index);
            return;
          }

          var threshold = width * 0.2;
          if (dx < -threshold) snapTo(index + 1);
          else if (dx > threshold) snapTo(index - 1);
          else snapTo(index);
        },
        { passive: true }
      );
    }

    function applyMode() {
      images = Array.from(link.querySelectorAll('img.product-card__image'));
      hasMultiple = images.length > 1;

      if (isMobile()) {
        ensureMobileTrack();
      } else {
        images.forEach(function (img) {
          img.style.position = '';
          img.style.inset = '';
          img.style.flex = '';
          img.style.width = '';
          img.style.height = '';
          img.style.objectFit = '';
          img.style.transition = '';
          img.style.opacity = '';
          img.style.visibility = '';
          img.style.pointerEvents = '';
        });

        setActiveDesktop(0);
      }
    }

    bindDesktop();
    bindMobileDrag();
    applyMode();

    if (!card.dataset.productCardResizeBound) {
      card.dataset.productCardResizeBound = 'true';
      window.addEventListener('resize', function () {
        clearTimeout(window.__pcardResizeT);
        window.__pcardResizeT = setTimeout(applyMode, 60);
      });
    }
  }

  function initAll(root) {
    var scope = root || document;
    var cards = scope.querySelectorAll('[data-product-card]');
    cards.forEach(function (card) {
      initOneCard(card);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);

    var grid =
      document.querySelector('#CollectionProductGrid') ||
      document.querySelector('.product-grid') ||
      document.querySelector('.collection-grid') ||
      document.querySelector('.product-list') ||
      document.body;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (!m.addedNodes || !m.addedNodes.length) return;
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('[data-product-card]')) {
            initOneCard(node);
          } else if (node.querySelectorAll) {
            initAll(node);
          }
        });
      });
    });

    observer.observe(grid, { childList: true, subtree: true });
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();


/// Footer Big Logo Fit ///
(function () {
  function fitFooterBigLogoText(root) {
    var scope = root || document;
    scope.querySelectorAll('.footer__big-logo-text').forEach(function (el) {
      var cropWrap = el.closest('.footer__big-logo-crop');
      var fitWrap = el.closest('.footer__big-logo-fit');
      if (!cropWrap || !fitWrap) return;

      el.style.setProperty('--fit', 1);
      cropWrap.style.removeProperty('--cropH');

      var wrapW = fitWrap.getBoundingClientRect().width;
      var textW = el.scrollWidth;
      if (!wrapW || !textW) return;

      var s = wrapW / textW;
      el.style.setProperty('--fit', s);

      requestAnimationFrame(function () {
        var scaledH = el.getBoundingClientRect().height;
        var cropPercent = parseFloat(getComputedStyle(cropWrap).getPropertyValue('--crop')) || 0;

        var cropPx = scaledH * (cropPercent / 100);
        var finalH = Math.max(0, scaledH - cropPx);

        cropWrap.style.setProperty('--cropH', finalH + 'px');
        el.style.setProperty('--cropShift', cropPx + 'px');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    fitFooterBigLogoText(document);
  });

  document.addEventListener('shopify:section:load', function (e) {
    fitFooterBigLogoText(e.target);
  });

  window.addEventListener('resize', function () {
    clearTimeout(window.__fitFooterLogoT);
    window.__fitFooterLogoT = setTimeout(function () {
      fitFooterBigLogoText(document);
    }, 80);
  });
})();

/// Page Loader ///
(function () {
  var loader = document.getElementById('pageloader');
  if (!loader) return;

  var active = false;

  function show(noAnim) {
    if (active) return;
    active = true;

    if (noAnim) loader.classList.add('no-anim');
    loader.classList.add('show');

    if (noAnim) {
      requestAnimationFrame(function () {
        loader.classList.remove('no-anim');
      });
    }
  }

  function hide() {
    console.log('[PageLoader] Hiding');
    loader.classList.remove('show');
    active = false;

    document.documentElement.classList.remove('pageloader-hide-body');
    document.documentElement.classList.remove('pageloader-force-show');
  }

  document.addEventListener('DOMContentLoaded', function () {
    show(true);
  });

  if (document.readyState === 'complete') {
    hide();
  } else {
    window.addEventListener('load', function () {
      console.log('[PageLoader] Window loaded');
      setTimeout(hide, 80);
    });
  }

  window.addEventListener('pageshow', function () {
    hide();
  });

  function samePage(href) {
    try {
      var u = new URL(href, location.href);
      return u.pathname === location.pathname && u.search === location.search;
    } catch (e) {
      return true;
    }
  }

function shouldHandle(a, e) {
  if (!a || e.defaultPrevented) return false;
  if (a.classList && a.classList.contains('js-cart-toggle')) return false;
  if (a.closest && a.closest('.js-cart-toggle')) return false;


  const href = a.getAttribute('href');
  if (!href) return false;

  if (
    href === '#' ||
    href === '' ||
    href.startsWith('javascript:') ||
    href.startsWith('mailto:') ||
    href.startsWith('tel:')
  ) {
    return false;
  }

  if (href.indexOf('/cart') !== -1 && document.getElementById('CartDrawer')) return false;

  if (href.startsWith('#')) return false;

  if (
    a.closest('.menu-item') &&
    a.parentElement.querySelector('.submenu, .dropdown, .sub-menu')
  ) {
    return false;
  }

  try {
    const u = new URL(href, location.href);
    if (u.pathname === location.pathname && u.search === location.search) {
      return false;
    }
  } catch (e) {
    return false;
  }

  return true;
}



  document.addEventListener(
    'click',
    function (e) {
      var a = e.target.closest && e.target.closest('a');
      if (!shouldHandle(a, e)) return;

      e.preventDefault();
      show(false);

      setTimeout(function () {
        location.href = a.href;
      }, 60);
    },
    true
  );

  setTimeout(hide, 5000);
})();
